import KeyboardDismissView from "@app/hoc/KeyboardDismissView"
import ScreenWrapper from "@app/hoc/ScreenWrapper"
import { PrivateStackParamList } from "@app/navigationApp/types"
import CommonHeader from "@app/sharedComponents/Header/Header"
import { ThemedText, ThemedView } from "@app/theme"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { ActivityIndicator, ScrollView, StyleSheet, View } from 'react-native';
import { getApplicationId } from "../FetchPortfolio/utils"
import { endpoints } from "@app/api/apis"
import axios from "axios"
import { useAppDispatch, useAppSelector } from "@app/store/hooks"
import Accordion from "./components/Accordion"
import PortfolioSummary from "./components/PortfolioSummary"
import { setAuthCAS, setMinimumEligibleLimit } from "@app/store/slices/applicationSlice"
import { useEffect, useState } from "react"
import AmountCard from "@app/sharedComponents/AmountCard"
import Button from "@app/sharedComponents/Button/Button"
import ErrorIcon from "@app/assets/svg/ErrorIcon"
import { useIsEnhanceLimit } from "@app/hooks/useIsEnhanceLimit"
import { EnhanceLimitCard } from "../MFCentral/MFCentralAnchor/components/EnhanceLimitCard"
import { usePledgeData } from "@app/hooks/usePledgeData"
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder"
import LinearGradient from "react-native-linear-gradient"
import handleApiErr from "@app/helper/handleApiErr"
import { showErrorSheet } from "@app/store/slices/errorSlice"
import { updatePartnerParams } from "@app/store/slices/platformSlice"
import { trackEvent } from "@app/utils"

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'MF_PLEDGE_PORTFOLIO'>

const MfPledgePortfolio = ({ navigation, route }: ScreenProps) => {
    const { userDetails } = useAppSelector((state) => state.auth);
    const [expanded1, setExpanded1] = useState(true);
    const [expanded2, setExpanded2] = useState(false);
    const [accordion2Disabled, setAccordion2Disabled] = useState(true);
    const [initDataLoading, setInitDataLoading] = useState(false);
    const { authCAS, minimumEligibleLimit } = useAppSelector((state) => state.application);
    const dispatch = useAppDispatch();
    const { isFromEnhanceLimit } = useIsEnhanceLimit();
    const { pledgeData } = usePledgeData();
    const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

    const [ctaLoading, setCtaLoading] = useState(false);

    const getPledgeLimit = async () => {
        setInitDataLoading(true);
        const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
        const url = endpoints.pledgeLimit + applicationId;
        axios.get(url).then((response) => {
            dispatch(setAuthCAS(response?.data?.stepResponseObject));
            dispatch(updatePartnerParams({showCall:response?.data?.stepResponseObject?.availableCreditAmount >= (response?.data?.stepResponseObject?.minimumEligibleLimit?.amount || 0)}))
        }).catch((error) => {
            if (error?.data?.statusCode && handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: error?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
        }).finally(() => {
            setInitDataLoading(false);
        });
    }

    const getEvaluate = async ({ successCallback, errorCallback }: { successCallback?: (response: any) => void, errorCallback?: (error: any) => void }) => {
        const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
        const url = endpoints.evaluate;
        return axios.post(url, {
            applicationId: applicationId,
        }).then((response) => {
            successCallback?.(response);
        }).catch((error) => {
            if (error?.data?.statusCode && handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: error?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
            errorCallback?.(error);
        });
    }

    useEffect(() => {
        getPledgeLimit();
        trackEvent('UNLOCK_LIMIT_PAGE_VIEWED');
    }, [])

    const handleContinueToCheckLimit = async () => {
        setCtaLoading(true);
        await getEvaluate({
            successCallback: async (response) => {
                await getPledgeLimit();
                setAccordion2Disabled(false);
                dispatch(setMinimumEligibleLimit(response?.data?.minimumEligibleLimit));
            }
        }).then(() => {
            setExpanded2(true);
            setExpanded1(false);

        }).finally(() => {
            setCtaLoading(false);
        });
      
    }

    return (
        <>
            <ScreenWrapper screenName={route.name}>
                <KeyboardDismissView>
                    <ThemedView flex={1} style={{ backgroundColor: 'white' }}>
                        <CommonHeader
                            label= {isFromEnhanceLimit ? 'Eligible limit' : 'Unlock credit limit'}
                            navigation={navigation}
                            pageName={route.name}
                        />
                        <ScrollView
                            showsVerticalScrollIndicator={false}
                        >
                            <ThemedView style={[ls.bodyContainer, {paddingTop: isFromEnhanceLimit ? 16 : 24}]} backgroundColor='bg-surface-primary'>
                                <ThemedView>
                                        {
                                            isFromEnhanceLimit &&
                                            <ThemedView style={{ paddingHorizontal: 16 }}>
                                                <EnhanceLimitCard creditLimit={pledgeData?.stepResponseObject?.existingSanctionedLimit || 0} />
                                            </ThemedView>
                                        }
                                    <ThemedView height={1} bg='border-secondary' marginBottom="lg" />
                                    <Accordion
                                        id='1'
                                        title='1. Get portfolio'
                                        isExpanded={expanded1}
                                        content={
                                                initDataLoading ?
                                                <ThemedView style={{ margin: 16, height: 250, justifyContent: 'center', alignItems: 'center'}} borderWidth={1} borderColor="border-secondary" borderRadius="sm">
                                                    <ShimmerPlaceholder style={{ width: '100%', height: '100%' }} />
                                                </ThemedView>
                                                :
                                                <>
                                                    <PortfolioSummary
                                                        navigation={navigation}
                                                        route={route}
                                                        handleContinueToCheckLimit={handleContinueToCheckLimit}
                                                        ctaLoading={ctaLoading}
                                                    />
                                                </>
                                            
                                        }
                                        onToggle={(isExpanded) => {
                                            if (isExpanded === true) {
                                                setExpanded2(false)
                                                setAccordion2Disabled(true)
                                            } else {
                                                trackEvent('MF_PLEDGE_PORTFOLIO_RTA_FETCH_DROPDOWN_CLOSED')
                                            }
                                            setExpanded1(isExpanded)
                                        }}
                                    />
                                    <Accordion
                                        id='2'
                                        title='2. Set credit limit'
                                        isExpanded={expanded2}
                                        content={
                                            <ThemedView style={{ paddingHorizontal: 16, marginTop: 16 }}>
                                                <AmountCard
                                                    availableCreditAmount={authCAS?.availableCreditAmount || 0}
                                                    totalPortfolioAmount={authCAS?.totalPortfolioAmount || 0}
                                                />
                                                <ThemedView style={{ height: 16 }} />
                                                <ThemedView style={{ height: 16 }} />
                                                {
                                                    minimumEligibleLimit?.isEligible === false &&
                                                    <ThemedView backgroundColor="bg-fill-error" paddingHorizontal="md" paddingVertical="sm" borderRadius="sm" marginBottom="md">
                                                        <ThemedView style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                            <ThemedView style={{ width: 24, height: 24 }} justifyContent="center" alignItems="center">
                                                                <ErrorIcon />
                                                            </ThemedView>
                                                            <ThemedView style={{ marginLeft: 8 }} flex={1}>
                                                                <ThemedText color="text-primary" variant="b4r">
                                                                    {minimumEligibleLimit?.nonEligibleDisplayReason}
                                                                </ThemedText>
                                                            </ThemedView>
                                                        </ThemedView>
                                                    </ThemedView>
                                                }
                                                <Button
                                                    eventName={'CONTINUE_TO_SET_CREDIT_LIMIT_BUTTON'}
                                                    additionalProperties={{
                                                        source: 'MF_PLEDGE_PORTFOLIO',
                                                        availableCreditAmount: authCAS?.availableCreditAmount,
                                                        totalPortfolioAmount: authCAS?.totalPortfolioAmount
                                                    }}
                                                    label={'Continue to set credit limit'}
                                                    handlePress={async () => {
                                                        //@todo: fix this
                                                        navigation.navigate("SET_CREDIT_LIMIT");
                                                    }}
                                                    type={'SOLID'}
                                                    size='MD'
                                                    bg='bg-primary'
                                                    textColor='text-primary'
                                                    disabled={minimumEligibleLimit?.isEligible === false}
                                                    buttonLoader={false}
                                                />
                                            </ThemedView>
                                        }
                                        isDisabled={accordion2Disabled}
                                        onToggle={(isExpanded) => {
                                            isExpanded &&
                                                setExpanded2(isExpanded)
                                        }}
                                    />
                                </ThemedView>
                            </ThemedView>
                        </ScrollView>
                    </ThemedView>
                </KeyboardDismissView>
            </ScreenWrapper>
        </>
    )
}

export default MfPledgePortfolio;


const ls = StyleSheet.create({
    bodyContainer: {
        flex: 1,
        // paddingVertical: 24,
    }
});